import { render, staticRenderFns } from "./WebFooter.vue?vue&type=template&id=4fefa7d4&scoped=true&"
import script from "./WebFooter.vue?vue&type=script&lang=ts&"
export * from "./WebFooter.vue?vue&type=script&lang=ts&"
import style0 from "./WebFooter.vue?vue&type=style&index=0&id=4fefa7d4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fefa7d4",
  null
  
)

export default component.exports